import axios from "./axios";

export const registerYourEntity = async (body: any) => {
  try {
    const response = await axios.post(`/public/football-entities/contact-sales`, body);
    return response;
  } catch (err: any) {
    if (err.response.data.errors) throw new Error(err.response.data.errors);
    throw new Error(err + " Failed in register your entity API");
  }
};

export const joinWaitingList = async (body: { email?: string; phoneNumber?: string }) => {
  try {
    const response = await axios.post(`/public/football-entities/join-waiting-list`, body);
    return response;
  } catch (err: any) {
    if (err.response.data.errors) throw new Error(err.response.data.errors);
    throw new Error(err + " Failed in register your entity API");
  }
};
